<template>
<div class="w-100 text-center" :class="p_main">

  <LoadingSpinner v-if="loading" />

  <img src="@/assets/images/launch.png" class="mt-5" v-if="!loading && condition" />
  <div class="mt-3 text-center" v-if="!loading && condition">
    <span class="font-weight-light ft-1-5 text-center text-secondary">
      {{ $t('lang.label.noresultsfound') }}
    </span>
  </div>
</div>
</template>


<script>


import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  components:{
    LoadingSpinner
  },
  props: {
    p_main:{
      default: 'pt-5'
    },
    loading: {
      default: true,
    },
    condition: {
      default: false,
    },

  },
}

</script>
